import { useSearchParams, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Profile from "@/pages/Profile";
import CompanySettings from "@/components/app/CompanySettings";
import { UserRound, Building2 } from "lucide-react";

const TABS = [
  { key: "profile", label: "Profil Saya", icon: UserRound },
  { key: "company", label: "Perusahaan", icon: Building2, ownerOnly: true },
];

export default function Settings() {
  const [sp, setSp] = useSearchParams();
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;

  const isOwner = user.role === "owner";
  const rawTab = sp.get("tab") || "profile";
  const tab = TABS.some((t) => t.key === rawTab && (!t.ownerOnly || isOwner)) ? rawTab : "profile";

  const setTab = (key) => setSp({ tab: key }, { replace: true });
  const visibleTabs = TABS.filter((t) => !t.ownerOnly || isOwner);

  return (
    <div className="space-y-6" data-testid="settings-page">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-[#A0A3A8] mb-2 font-semibold">Akun & Preferensi</p>
        <h1 className="text-3xl md:text-[34px] tracking-tight font-bold text-[#090808]">Pengaturan</h1>
      </div>

      {/* Tab bar */}
      <div className="flex items-center border-b border-[#DCE0E7] overflow-x-auto" data-testid="settings-tab-bar">
        {visibleTabs.map((t) => {
          const Ico = t.icon;
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              data-testid={`settings-tab-${t.key}`}
              className={`inline-flex items-center gap-1.5 px-4 py-3 text-sm border-b-2 transition-colors whitespace-nowrap ${
                active ? "text-[#090808] border-[#090808] font-bold" : "text-[#A0A3A8] border-transparent hover:text-[#626061]"
              }`}
            >
              <Ico className="w-3.5 h-3.5" /> {t.label}
            </button>
          );
        })}
      </div>

      {tab === "profile" && (
        <Profile embedded hideHighlights={isOwner} hideCompany />
      )}
      {tab === "company" && isOwner && (
        <CompanySettings />
      )}
    </div>
  );
}
